import { render, staticRenderFns } from "./DashboardCliente.vue?vue&type=template&id=46740d08&"
import script from "./DashboardCliente.vue?vue&type=script&lang=js&"
export * from "./DashboardCliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports